<div [ngClass]="{ 'body-container': tableConfig }" class="total-extraction-table">
    <app-main-table class='mt-data-table' [tableConfig]="tableConfig" ></app-main-table>
</div>
